import React from 'react';
// import { useDispatch, useSelector } from 'react-redux';

import {Button, ButtonGroup, ClickAwayListener, Grow, Paper, Popper, MenuItem, MenuList} from '@mui/material';
import { ArrowDropDown, Stop, PlayArrow, RestartAlt } from '@mui/icons-material';
import { useState } from 'react';
import { useRef } from 'react';


export default function ProcessSplitButton({ handleProcessClick, running, darkMode, demoUser }) {
  const options = demoUser ? ['Process All'] : ['Process All', 'Re-fit All'];

  const [open, setOpen] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [refit, setRefit] = useState(false);
  const anchorRef = useRef(null);

  // const dispatch = useDispatch();

  const handleClick = () => {
    switch(options[selectedIndex]) {
      case "Process All":
        console.log('Processing all wells...');
        handleProcessClick(false);
        break;
      case "Re-fit All":
        console.log('Re-fitting all wells...');
        handleProcessClick(true);
        break;
      default:
        break;  
    };
  };

  const handleMenuItemClick = (event, index) => {
    setSelectedIndex(index);
    if (index === 0) {
      setRefit(false);
    } else if (index === 1) {
      setRefit(true);
    };

    setOpen(false);
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  return (
    // <Grid container direction="column" alignItems="flex-end" style={{backgroundColor: "red"}}>
    //   <Grid item xs={12}>
    <div ref={anchorRef} style={{zIndex: 420}}>
      <ButtonGroup size="small" variant="contained" style={{border: 'none', height: 28}}>
        <Button size="small" onClick={handleClick} startIcon={running ? <Stop /> : refit ? <RestartAlt /> : <PlayArrow />} style={{border: 'none', color: darkMode ? '#000' : '#fff'}} color={(darkMode ? "inherit" : "primary")}>{running ? 'Stop' : options[selectedIndex]}</Button>
        <Button
          color={(darkMode ? "inherit" : "primary")}
          // size="small"
          onClick={handleToggle}
          style={{border: 'none', width: 16, color: darkMode ? '#000' : '#fff'}}
          size="small"
        >
          <ArrowDropDown />
        </Button>
      </ButtonGroup>
      <Popper open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal>
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList id="split-button-menu">
                  {options.map((option, index) => (
                    <MenuItem
                      key={option}
                      // disabled={index === 2}
                      selected={index === selectedIndex}
                      onClick={(event) => handleMenuItemClick(event, index)}
                    >
                      {option}
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </div>
  );
}